<template>
  <div class="home " style="padding-bottom: 120px; padding-top: 50px">
    <b-row class="m-0 pt-3 justify-content-center" style="padding-top: 0px !important;">
       <b-img :src="require(`@/assets/logos/eatDoradoLogo.png`)" width="300px" style="max-width: 90%; height: 190px" fluid alt="eatDorado Logo"></b-img>  
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center" style="padding-top: 0px !important;">
      <h3 class="hover-3 mx-2 text-center" > <strong> Account aktivieren</strong></h3>
    </b-row>
    <b-row class="m-0 justify-content-center" style="">
      <b-col cols="12" md="6" style="z-index: 101">
        <div class="mx-5" >
          <b-row class="m-0 justify-content-center">
            <b-img :src="require(`@/assets/images/undraw_authentication.svg`)" style="height: 250px" fluid alt="eatDorado Logo"></b-img>  
          </b-row>
          <div class="mt-5">
            <b-button style="width: 100%" size="md" variant="dark" @click="activateAccount">Account aktivieren <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          </div>
        </div>
      </b-col>
      
    </b-row>
    
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
export default {
  name: 'Resetpassword',
  data: () => {
    return {
      form: {
        new_password: '',
        re_new_password: ''
      }
    }
  },
  components: {
    Footer
  },
  computed: {
    authError(){
      return this.$store.getters.authError
    },
    authMessage(){
      return this.$store.getters.authMessage
    },
    updating(){
      return this.$store.getters.updating
    },
    resetUid(){
      return this.$route.query.uid
    },
    activationToken(){
      return this.$route.query.token
    },
  },
  mounted(){

  },
  methods: {
    activateAccount(){
      const payload = {
        token: this.activationToken
      }
      this.$store.dispatch('activateAccount', payload)
    }
  }
}
</script>

<style lang="scss">
  .sub-header {
    position: relative;
    top: -18vh;
  }

  .sub-end {
    position: relative;
    top: -50vh;
    height: 40vh;
  }

  .triangle-modal {
    position: relative;
    top: -1px;
    height: 7vh;
    clip-path: polygon(0 0,0 100%,100% 0,100% 0);
    -webkit-clip-path: polygon(0 0,100% 0,100% 0,0 100%);
  }


  .showcase-invert {
    transition: all .5s;
    padding: 15px;
    border-radius: 5px;
    border: none;
    //box-shadow: 1px 1px 2px rgba(255,255,255,0.05), 1px 1px 2px rgba(0,0,0, .5) !important
    //box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
  }

  .brand-header {
    box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(60deg,#26c6da,#00acc1);
    &:hover {
        transform: translate(0, -10px);
    }
  }
</style>